<section class="aarni-font w-full shadow border-b mt-[80px] py-[50px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>

    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 md:max-h-screen md:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">B.Tech CSE Specialisations</h2>
                    <div class="">
                        <a
                            [href]="'schools/arni-school-of-technology/btech-cse/artificial-intelligence-and-machine-learning'"
                            [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in Artificial Intelligence And Machine Learning', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in Artificial Intelligence And Machine Learning'}"
                            class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Artificial Intelligence And Machine Learning</span>
                        </a>
                        <a [href]="'schools/arni-school-of-technology/btech-cse/data-science'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in Data Science', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in Data Science'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Data Science</span>
                        </a>
                        <a [href]="'schools/arni-school-of-technology/btech-cse/cloud-computing'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in Cloud Computing', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in Cloud Computing'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Cloud Computing</span>
                        </a>
                        <a [href]="'schools/arni-school-of-technology/btech-cse/cyber-security'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in Cyber Security', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in Cyber Security'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Cyber Security</span>
                        </a>
                        <a [href]="'schools/arni-school-of-technology/btech-cse/blockchain'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in Blockchain', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in Blockchain'}"
                             class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Blockchain</span>
                        </a>
                        <a [href]="'schools/arni-school-of-technology/btech-cse/iot-applications'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech CSE in IOT Applications', 'text-blue-600 bg-white' : pageTitle !== 'BTech CSE in IOT Applications'}"
                             class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IOT Applications</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow  hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                              <span
                                  class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium   md:text-[16px] xl:text-xl ">Faculty</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Testimonials</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                               <span
                                   class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                                    <i class="fa fa-phone text-2xl"></i>
                              </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Leadership</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1 text-justify">
            <div class="md:p-12 shadow-lg border-gray-200 bg-white h-fit ">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'BTech CSE in Artificial Intelligence And Machine Learning'">
                    <p class="text-gray-500 text-justify my-3">The world is driven by automation, smart systems, and
                        rapid innovation. Machine Learning (ML) and
                        Artificial Intelligence (AI) play an important role in technological evolution. From
                        personalized recommendations on browsing to streaming apps, autonomous vehicles, and voice
                        assistance, to healthcare diagnostics, AI & ML are the core of modern innovation.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">Being a forward-thinking educational institution, ARNI
                        University is committed to developing
                        skilled professionals who can contribute to society with their exceptional technical skills and
                        knowledge. Our B. Tech in Artificial Intelligence & Machine Learning program is a 4-year
                        undergraduate degree program designed to equip students with the required proficiency to thrive
                        in an AI-driven world. </p>
                    <p class="text-gray-500 text-justify mb-3">The program is well-structured with a blend of
                        theoretical foundations with practical exposure,
                        focusing on programming, data analysis, machine learning algorithms, robotics, deep learning,
                        and real-world problem-solving. The course is perfect for those who are looking to develop their
                        career in IT, software development, and data analysis, etc. After a few semesters of learning
                        mathematics and physics in a modular style, students pursuing a B.Tech in Artificial
                        Intelligence and Machine Learning will transition to courses that focus on the fundamentals of
                        AI and Machine Learning.</p>
                    <p class="text-gray-500 text-justify mb-3">The candidate’s study extends beyond just artificial
                        intelligence; they are additionally familiar
                        with more complex facets of decorum. For example, they learn about augmented reality, deep
                        learning, and human-computer interaction. During this program, we also provide multidisciplinary
                        courses. Students may be required to study robotics, psychology, internet functioning, edge
                        computing, and computer program marketing.</p>
                    <p class="text-gray-500 text-justify mb-3">At ARNI, we provide an industry-aligned curriculum,
                        expert faculty, high-end lab infrastructure,
                        and research exposure to ensure students are job-ready and innovation-driven. Through our
                        cultivating curriculum, we trained ethical AI leaders, making sure that the future is not just
                        smart, but also responsible and inclusive.
                    </p>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Course Objectives
                    </h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>To comprehend the fundamentals of artificial intelligence and machine learning, the B. Tech
                            in Artificial Intelligence and Machine Learning program first focuses on AIML applications,
                            then moves on to statistics, discrete mathematics, and probability.
                        </li>
                        <li>The course focuses on the mathematical derivation of machine learning models and how to
                            apply them to labeled data and real-time applications.
                        </li>
                        <li>Algorithms for Intelligent Systems and Robotics, Machine Learning, Neural Networks,
                            Cognitive Analytics, Computational Linguistics and Natural Language Processing, Pattern
                            Recognition and Anomaly Detection, and Machine Learning Applications in Industries are among
                            the specialized subjects of the course.
                        </li>
                        <li>Students who complete the program will have a solid foundation in AI and ML in addition to
                            hands-on experience using these ideas to solve real-world issues.
                        </li>
                        <li>To promote innovation through involvement in national and international contests, patent
                            facilitation, and startup mentoring.
                        </li>
                        <li>In order to learn about new and practical applications of these concepts, the students
                            engage in research projects with a variety of academic members.
                        </li>
                        <li>To prepare students for the workforce through practical projects, coding contests,
                            internships, and joint research.
                        </li>
                    </ul>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Scope
                    </h3>
                    <p class="text-gray-500 my-3">The future scope of B. Tech in Artificial Intelligence and Machine
                        Learning is very promising.
                        Businesses that use AI engineering techniques are predicted to outperform their rivals by at
                        least 25% in terms of operationalizing AI models by 2026, which bodes well for the future of a
                        B. Tech in Artificial Intelligence and Machine Learning.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>As per reports by PwC, AI could contribute up to $15.7 trillion to the global economy by
                            2030.
                        </li>
                        <li>India alone will need more than 1 million AI professionals in the coming years, according to
                            NASSCOM.
                        </li>
                        <li>AI & ML are already used in various industries such as healthcare, education, logistics, and
                            other fields that increase productivity and efficiency in operational tasks.
                        </li>
                        <li>With the power of automation and data science, the skilled professional will get high-paying
                            tech jobs globally.
                        </li>
                        <li>AI Engineer / Machine Learning Engineer, Data Scientist / Business Intelligence Analyst,
                            Robotics Developer, Natural Language Processing (NLP) Expert, Computer Vision Engineer,
                            Research Scientist in AI Labs, AI Product Manager, and Software Developer (AI Integrations)
                            are some of the common profiles B. Tech in AI & ML can work upon.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">B. Tech in Artificial Intelligence & Machine Learning is your gateway
                        to a meaningful and
                        impactful career in technology, where you not only shape your future—but contribute to shaping
                        the future of the world.
                    </p>
                </div>
                <div *ngIf="pageTitle === 'BTech CSE in Data Science'">
                    <p class="text-gray-500 text-justify my-3">The ARNI School of Technology's B.Tech. CSE Data Science
                        curriculum is developed to give students the abilities and information needed to succeed in the
                        fast-paced field of data science. This four-year undergraduate curriculum is broken up into
                        eight semesters. It is a rigorous, skill-focused program that provides ample hands-on training
                        for creating analytics business models.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">The main goal of the program is to use a variety of
                        statistical tools to find patterns in data and derive insightful information. Before beginning
                        data analysis, students will receive in-depth instruction on data extraction, wrangling, and
                        pre-processing. The courses allow students to become experts in a certain discipline by focusing
                        on a particular subject or talent within the field. </p>
                    <p class="text-gray-500 text-justify mb-3">The program acknowledges the need for qualified experts
                        in the field as Data Science and AI continue to gain popularity. Our curriculum is designed to
                        encourage critical thinking and self-directed learning. Students are encouraged by ARNI to
                        actively read industry publications, research papers, conferences, and workshops. Additionally,
                        the program emphasizes real-world experience through capstone projects.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">Our team of industry professionals, who serve as both
                        instructors and seasoned mentors, gives students practical experience with real-world data
                        difficulties and allows them to apply their theoretical knowledge in real-world situations.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">The ARNI University B.Tech. Computer Science &
                        Engineering (Data Science) curriculum is a thorough and progressive educational experience. It
                        equips students to become skilled data scientists who can draw insightful conclusions from
                        intricate information. Graduates are prepared to succeed in the fascinating fields of data
                        science, artificial intelligence, and analytics across a range of sectors thanks to specialized
                        instruction and real-world experience.</p>

                    <h3 class="font-semibold text-[18px] mt-4">Career Objectives</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>Students enrolled in the B.Tech. CSE in Data Science program becomes proficient in key data
                            science tools and platforms, prepares for real-world data analysis difficulties, including
                            SAS, Microsoft Power BI, Tableau, TensorFlow, and more.
                        </li>
                        <li>The course allows for strengthening the foundational concepts and advanced learning in
                            programming, algorithms, and data structures, ensuring professional knowledge and skills
                            enhancements in data science.
                        </li>
                        <li>To provide practical experience and exposure to advanced technology in well-maintained
                            computer labs furnished with top-tier equipment, fast internet, and cloud computing
                            resources.
                        </li>
                        <li>Offering students hands-on experience with data engineering, data visualization, neural
                            networks, and predictive modeling. We concentrate on gaining proficiency in employing
                            contemporary infrastructure to manage massive datasets and real-time data streams.
                        </li>
                        <li>to equip students for high-impact positions in startups, government, healthcare, finance, IT
                            firms, and other research fields. Providing real-world projects and case studies to
                            stimulate innovation and ethical practice among the students.
                        </li>
                    </ul>

                    <h3 class="font-semibold text-[18px] mt-4">Scope</h3>
                    <p class="text-gray-500 my-3">The B.Tech. Computer Science & Engineering (Data Science) program at
                        ARNI School of Technology prepares students to handle vast data, aiding critical business
                        decisions. The program prepares graduates for a data-driven world influenced by emerging
                        technologies like Artificial Intelligence, Cloud services, AR/VR, IoT, Big Data, Automated
                        Machine Learning, and Quantum Computing.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>As per Analytics Insight (2024), the Indian Data Science market is expected to reach USD 16
                            billion by 2025, growing at a CAGR of 36%.
                        </li>
                        <li>According to the World Economic Forum, Data Science and AI-related roles will create over 97
                            million new jobs globally by 2027.
                        </li>
                        <li>Tech giants like Amazon, Google, Microsoft, Infosys, TCS, Accenture, Flipkart, and Walmart
                            are aggressively hiring data science professionals for high-paying roles.
                        </li>
                        <li>The undergraduates in this program go on to become Data Scientists, Data Engineers, Data
                            Warehouse Architects, Business Intelligence Analysts, and Big Data Architects.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">With access to AI labs, expert mentorship, global learning resources,
                        and industry-aligned projects, students are groomed to lead the next wave of data-driven
                        transformation.
                    </p>
                </div>
                <div *ngIf="pageTitle === 'BTech CSE in Cloud Computing'">
                    <p class="text-gray-500 text-justify my-3">Cloud computing is now the cornerstone of contemporary IT
                        operations as the world transitions to digital infrastructure. These days, the cloud supports
                        industries including e-commerce, healthcare, banking, and even government agencies. Following
                        this rapid shift, the most sought-after program in the tech industry is a B.Tech. in Computer
                        Science & Engineering with a focus on Cloud Computing.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">The four-year undergraduate B.Tech in Cloud Computing
                        program is divided into eight semesters. Teaching students about internet-based computing
                        services—that is, online applications and services—is the aim of this course. This program,
                        which focuses on data storage capacity and on-demand computing, helps students specialize in the
                        field of cloud computing.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">Cloud architecture, virtualization technology, cloud
                        storage, cloud security, and other topics are covered in the program's curriculum. Through
                        hands-on training, assignments, and projects, the program also emphasizes learning by
                        performing, enabling students to apply what they have learned to real-world situations.
                        Additionally, the curriculum gives students access to industrial visits and internships, which
                        help them get real-world experience and exposure to the business.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">The program's overall goal is to prepare students for a
                        future in the fast-developing fields of virtualization and cloud computing, where they will be
                        able to use their knowledge and abilities to address practical issues. Students can apply the
                        concepts they have learnt in real-world scenarios due to the program's emphasis on practical
                        learning. To prepare students for a prosperous future in the sector, the curriculum also offers
                        internships and industrial experience possibilities.
                    </p>
                    <h3 class="font-semibold text-[18px] mt-4">Career Objectives</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>To train students in areas like cloud infrastructure, Cloud Computing, virtualization,
                            cloud software, deployment, modeling and analysis, cloud services applications, and so on.
                        </li>
                        <li>Equip students to build a real cloud infrastructure, configuring and deploying virtual
                            machines, storage, networking, and compute power using AWS, Azure, and GCP.
                        </li>
                        <li>Create opportunities for students and prepare them for the real-world cloud projects,
                            including web hosting, app deployment, and serverless functions.
                        </li>
                        <li>Enable students to use scripting languages, develop programs such as DevOps tools (Docker,
                            Jenkins, Kubernetes), and Infrastructure as Code (IaC) practices.
                        </li>
                        <li>To ensure cloud security and compliance, providing a deep understanding of cloud
                            infrastructure, identity management, encryption, and regulatory compliance (GDPR, HIPAA,
                            etc.).
                        </li>
                    </ul>

                    <h3 class="font-semibold text-[18px] mt-4">Scope</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>Cloud computing has a very bright future since it offers businesses enormous potential for
                            technical advancements. The B. Tech in Cloud Computing program prepares students for various
                            career paths, including multi- or hybrid cloud, edge computing, IoT, AI, serverless
                            computing, Kubernetes, and disaster recovery.
                        </li>
                        <li>The global cloud computing market is expected to reach USD 832.1 billion by 2025, requiring
                            skilled professionals
                        </li>
                        <li>India’s cloud market is growing at 25% CAGR and is projected to exceed $13 billion by 2026
                            (NASSCOM).
                        </li>
                        <li>Freshers in cloud roles can expect an average package of ₹6–9 LPA. And professionals with
                            certifications (like AWS or Azure) and 3–5 years of experience can command ₹10–12 LPA or
                            more.
                        </li>
                        <li> Cloud computing skills are now essential in various sectors, including Banking & Financial
                            Services, Healthcare & Pharma, Media & Entertainment, Education Technology, Retail & Supply
                            Chain, and Startups & SaaS-based companies.
                        </li>
                        <li>The graduates will get high-paying jobs and managerial-level posts such as Cloud Engineer,
                            Cloud Solutions Architect, DevOps Engineer, Cloud Security Specialist, AWS/Azure/GCP
                            Consultant, Cloud Application Developer, and System Administrator – Cloud Infrastructure.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">ARNI University is the most prestigious educational institute in North
                        India. At ARNI University, we integrate value-driven learning, real-world experience, and
                        academic achievement. Students are prepared to spearhead the next wave of data-driven
                        transformation through industry-aligned projects, global learning resources, professional
                        mentoring, and access to AI laboratories.
                    </p>
                </div>
                <div *ngIf="pageTitle === 'BTech CSE in Cyber Security'">
                    <p class="text-gray-500 text-justify my-3">With an increasing number of businesses shifting from
                        offline to online, this has raised concerns about online data security. The issues of data
                        breaches and tampering are the foremost concern globally. B. Tech in Cyber Security course
                        offered by ARNI University trains individuals to safeguard data in the digital space. This
                        4-year program is designed to prepare students for the evolving world of cybersecurity,
                        information assurance, and ethical hacking.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">With a comprehensive expertise in various aspects of
                        cybersecurity, this course offers exposure to various topics, including networking security,
                        cryptography, and cyber laws. The curriculum is designed to keep pace with the latest industry
                        trends and practices, ensuring that students are well-prepared for the workforce.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">To provide the best learning experience to enhance the
                        knowledge space of the students, ARNI School of Technology blends theoretical learning with
                        practical sessions that include lab exercises, real-world projects, and field experience.
                        Moreover, we helped students to secure internships during their program with our strong industry
                        collaborations. This helps student to solve challenges and implement their learning in
                        real-world to understand the pros and cons of the specialization.</p>
                    <p class="text-gray-500 text-justify mb-3">We have created a special area and qualified mentors to
                        support students during their educational journey. To create an employable workforce prepared to
                        take on challenging roles in the field of cybersecurity, the B.Tech. CSE (Cyber Security)
                        program is specifically designed to increase engineering graduates' mindfulness and redesign
                        their skills. It also helps to close the gap between academia and industry.</p>
                    <p class="text-gray-500 text-justify mb-3"> Overall, the B.Tech in Cyber Security degree equips
                        students with a comprehensive education and real-world experience, preparing them for the
                        cybersecurity sector.
                    </p>

                    <h3 class="font-semibold text-[18px] mt-4">Course Objectives</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>To emphasize the core principles of cybersecurity and provide a strong foundation in
                            computer science, networking, operating systems, and cybersecurity architecture.
                        </li>
                        <li>To master students or individuals in protecting cloud data using various tools and
                            techniques, such as data encryption, cryptography, access controls, firewalls, and VPNs to
                            secure information in motion and at rest.
                        </li>
                        <li>To train students with real-world ethical hacking skills, vulnerability assessment, and
                            penetration testing abilities to ensure data security and compliance.
                        </li>
                        <li>Build resilience against cyberattacks by enabling students to design secure systems, perform
                            threat modeling, and recover from breaches with business continuity planning.
                        </li>
                        <li>Promote exploration in emerging areas such as AI in cybersecurity, zero-trust architecture,
                            blockchain security, and biometric systems.
                        </li>
                        <li>To give students a hands-on grasp of cybersecurity principles and procedures, the B. Tech in
                            Cyber Security curriculum places a strong emphasis on practical exercises, projects, and
                            internships.
                        </li>
                    </ul>

                    <h3 class="font-semibold text-[18px] mt-4">Scope</h3>
                    <p class="text-gray-500 my-3">The future scope for students specializing in the course is highly
                        promising, as the global cybersecurity industry is projected high in the upcoming years. As
                        cybersecurity continues to play a crucial role in defending businesses and organizations against
                        cyber threats, students with this specialization have a wide range of career options available
                        to them, along with the potential for career advancement and growth.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>The Cybersecurity market in India is expected to witness significant growth in the coming
                            years. By 2025, the revenue in this market is projected to reach ₹US$3.30bn claimed by
                            Statista Market Forecast.
                        </li>
                        <li>Graduates will have a solid background in engineering, critical issue analysis, and
                            solution design, as well as the ability to carry out in-depth research to address
                            challenging problems.
                        </li>
                        <li>Government and private sectors are hiring data security experts to safeguard digital
                            infrastructure, banking systems, national security, and personal data.
                        </li>
                        <li> Students with a B. Tech in Cyber Security degree can pursue various career paths, including
                            security analyst, security engineer, network security administrator, cyber security
                            consultant, and incident responder.
                        </li>
                        <li>ARNI University offers a programme designed to provide skilled security professionals for
                            cloud data protection, combining practical and theoretical knowledge from experienced
                            cybersecurity professionals and computer science academics.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3"></p>
                </div>
                <div *ngIf="pageTitle === 'BTech CSE in Blockchain'">
                    <p class="text-gray-500 text-justify my-3">In the 21st century, blockchain technology has emerged as
                        one of the most disruptive innovations. It is an advanced database mechanism that shares
                        transparent information within the business networks. We at ARNI University offer B.Tech in
                        Computer Science Engineering with a specialization in Blockchain Technology to equip students
                        with the technical knowledge and skills, along with industry exposure and critical thinking
                        abilities.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">B.Tech in Computer Science Engineering (CSE) with a
                        specialization in Blockchain Technology is a four-year undergraduate program that focuses on the
                        principles and applications of blockchain technology, including distributed ledgers,
                        cryptocurrencies, and smart contracts.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">Following this unpredictable digital landscape,
                        Blockchain Technology is not limited to cryptocurrencies – the technology is widely used in
                        various sectors, especially in banks, real estate, voting systems, cybersecurity, and supply
                        chain. There are many possibilities for learners in the rapidly expanding field of blockchain.
                        Students can choose this specialization to explore the ample opportunities for employment and
                        take advantage of the strength of this ground-breaking platform.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">At ARNI University, we understand the gravity of the
                        specialization. Thus, we have created a robust curriculum to polish the understanding of
                        potential aspirants about blockchain technology. The course is designed with the guidance of
                        industry experts and scholars with modern techniques. The course allows students to explore the
                        foundation of blockchain, smart contracts, cryptography, distributed ledger systems, and
                        real-world applications.</p>
                    <p class="text-gray-500 text-justify mb-3">Additionally, project-based learning, practical exposure
                        through research labs, and mentorships from industry experts help our students gain practical
                        skills to face real-world challenges.</p>
                    <p class="text-gray-500 text-justify mb-3">We aim to produce next-gen innovators and leaders who can
                        reshape industries and contribute to a more secure and transparent digital ecosystem.
                    </p>
                    <h3 class="font-semibold text-[18px] mt-4">Course Objectives</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>The ability to create mathematical models and solve problems utilizing programming
                            techniques. Analyze real-time problems in finance, healthcare, and logistics using
                            blockchain technology and provide an appropriate solution with the help of suitable data
                            structures and algorithms.
                        </li>
                        <li> To develop the ability to create cryptocurrencies with a strong foundation in blockchain
                            architecture and cryptographic principles, with an in-depth understanding of applications,
                            future directions, and open research challenges.
                        </li>
                        <li> To strengthen the capacity to develop, construct, and implement a distributed application
                            and offer solutions utilizing blockchain technologies to improve business measures through
                            efficient and safe information sharing.
                        </li>
                        <li> To prepare students to explore legal and social aspects of blockchain adoption.
                        </li>
                        <li> Through their research and innovation skills, the graduates will offer long-term answers to
                            multidisciplinary global issues that are always evolving.
                        </li>
                    </ul>

                    <h3 class="font-semibold text-[18px] mt-4">Scope</h3>
                    <p class="text-gray-500 my-3">The growing demand for digital infrastructure in businesses increases
                        the demand for skilled professionals. Many industries are integrating blockchain for secure,
                        transparent operations. Blockchain Developer consistently ranks among the top 10 most in-demand
                        roles globally, with demand growing by over 2000% in recent years.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>According to Statista, global blockchain spending is projected to reach $19 billion by 2024,
                            and the demand for skilled blockchain professionals continues to rise.
                        </li>
                        <li>India is exploring CBDCs (Central Bank Digital Currencies) and blockchain applications in
                            public records, which will require a new generation of blockchain-savvy tech professionals.
                        </li>
                        <li>From banking and insurance to supply chains and real estate, blockchain experts are needed
                            to build scalable, secure, and tamper-proof solutions that solve real-world challenges.
                        </li>
                        <li> Graduates can pursue high-paying roles like Blockchain Developer, Smart Contract Engineer,
                            Blockchain Architect, DApp Developer, and Blockchain Consultant across industries like
                            finance, healthcare, logistics, cybersecurity, and governance.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">At ARNI University, we equip students with cutting-edge knowledge,
                        hands-on experience, and industry exposure to help them lead the next wave of innovation. With
                        global demand on the rise, this course ensures you graduate with future-ready skills, an
                        entrepreneurial mindset, and a strong foundation to thrive in the tech-driven world of
                        tomorrow.</p>
                </div>
                <div *ngIf="pageTitle === 'BTech CSE in IOT Applications'">
                    <p class="text-gray-500 text-justify my-3">The Internet of Things (IoT) is rising as the most
                        powerful technology that transforming the world rapidly. From smart homes and devices to
                        industrial automation and intelligent transport systems, IoT plays an important role in
                        streamlining applications. At ARNI University, the B.Tech in Computer Science & Engineering with
                        a specialization in IoT & Applications is designed to equip students with the skills, knowledge,
                        and vision needed to lead in this exciting domain.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">B.Tech CSE in IOT & Applications is a 4-year
                        undergraduate degree program that is designed to provide the fundamentals of computer science
                        with advanced IoT technologies such as sensors, wireless communication, cloud computing, and
                        real-time data analytics. The curriculum equips students to design, build, and manage IoT
                        systems that are comprehensive, secure, and smart.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">With access to industry-standard labs, experienced
                        faculty, and hands-on project-based learning, students gain real-time exposure to the
                        applications of IoT in sectors such as healthcare, agriculture, manufacturing, energy, and smart
                        cities.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">At ARNI University, we believe in creating future-ready
                        graduates who can innovate and solve real-world problems using IoT. Our student-centric approach
                        includes internships, industry mentorship, and support for research and entrepreneurship. If
                        you're passionate about creating a connected future and want to be at the forefront of the next
                        tech revolution, this is the course for you.
                    </p>

                    <h3 class="font-semibold text-[18px] mt-4">Course Objective</h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>To provide fundamental knowledge of IoT technologies and computer science that helps to
                            develop skills in embedded systems, wireless communication, sensor networks, and cloud-based
                            IoT platforms.
                        </li>
                        <li>To provide a thorough grasp of the different IoT sensors, including motion, temperature,
                            humidity, GPS, and accelerometers. This is essential for creating practical, sensor-driven
                            solutions.
                        </li>
                        <li>Help students to acquire excellence in programming languages crucial for IoT, such as
                            Python, JavaScript, Java, and C/C++, empowering them to create versatile IoT applications.
                        </li>
                        <li> To nurture critical thinking and innovation through real-world projects and case studies
                            that enable students to design, simulate, and implement end-to-end solutions.
                        </li>
                        <li>To train students for a dynamic career in IoT & Application development, data analysis, and
                            automation industries.
                        </li>
                    </ul>

                    <h3 class="font-semibold text-[18px] mt-4">Scope</h3>
                    <p class="text-gray-500 my-3">The ARNI School of Technology's B.Tech. Computer Science & Engineering
                        (Internet of Things & Application) curriculum promises a bright future in the quickly growing
                        Internet of Things (IoT) sector. This topic is centered on networked physical devices that are
                        embedded with sensors and software. These devices have the potential to transform industries
                        like manufacturing, transportation, healthcare, smart cities, and agriculture. Graduates of this
                        program will be prepared to enter a vibrant industry that is teeming with innovation and
                        opportunity.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>With the global IoT market expected to reach $650 billion by 2026 (Statista), graduates can
                            pursue roles such as IoT Developer, Embedded Engineer, System Architect, and IoT Analyst.
                        </li>
                        <li>IoT is revolutionizing industries like healthcare (remote monitoring), agriculture (smart
                            farming), manufacturing (Industry 4.0), and energy (smart grids).
                        </li>
                        <li>India’s Smart Cities Mission and Digital India campaign have created massive demand for IoT
                            professionals.
                        </li>
                        <li>Students can further pursue a Master’s or Ph.D. in areas like IoT, AI, Robotics, or Embedded
                            Systems.
                        </li>
                        <li>IoT opens doors for entrepreneurs to build innovative solutions in areas like wearable tech,
                            home automation, and logistics.
                        </li>
                        <li>With the rise in IoT adoption worldwide, skilled graduates can find opportunities both in
                            India and internationally.
                        </li>
                        <li>Graduates are well-positioned to succeed in positions like embedded systems engineer, IoT
                            solution architect, data analyst, and IoT software developer because they have a solid
                            foundation in IoT technologies, data analytics, and software development.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">ARNI University's B.Tech CSE in IoT & Applications program prepares
                        students for the technological revolution, preparing them for roles in smart infrastructure,
                        industrial automation, agriculture, healthcare, and wearable technologies.
                    </p>
                </div>
            </div>
        </div>
    </div>

</section>
